/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const documentConstants = {
    COST_REPORT_LIST: 'cost_report_list',
    INVOICES_LIST: 'invoices_list',
    VAT_LIST: 'vat_list',
    INVOICES_DATA_LIST: 'invoices_data_list',
    INVOICE_PUT: 'invoices_put',
    CUSTOM_DOCUMENT_ACTION: 'document_custom_action',
    FILE_DOWNLOAD: 'document_file_download',
    REQUEST_DOCUMENT: 'document_request',
};

export class DocumentActions extends defaultActions {}
